import Swiper, {Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination} from 'swiper';
import GLightbox from "glightbox";
import "./bugsystem.js";
import { PowerGlitch } from 'powerglitch';

  var _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function() {
    var u="https://matomo.atw.io/";
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', '39']);
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
  })();

PowerGlitch.glitch('.glitch--constantly', {
    playMode: 'always',
    createContainers: true,
    hideOverflow: false,
    timing: {
        duration: 3000,
        iterations: Infinity,
    },
    glitchTimeSpan: {
        start: 0,
        end: 1,
    },
    shake: {
        velocity: 2,
        amplitudeX: 0.2,
        amplitudeY: 0.2,
    },
    slice: {
        count: 6,
        velocity: 15,
        minHeight: 0.02,
        maxHeight: 0.15,
        hueRotate: true,
    },
});

const lightglitches = document.querySelectorAll('.glitch--light');
lightglitches.forEach(elem => {
    const randomDelay = Math.floor(Math.random() * 500); //Random delay between 0 and 3000ms
    elem.style.setProperty('--glitch-delay', `${randomDelay}ms`);
    PowerGlitch.glitch(elem, {
        playMode: 'always',
        createContainers: true,
        hideOverflow: false,
        timing: {
            duration: 5000,
            iterations: Infinity,
            delay: randomDelay,
        },
        glitchTimeSpan: {
            start: 0,
            end: 1,
        },
        shake: {
            velocity: 1,
            amplitudeX: 0.1,
            amplitudeY: 0.1,
        },
        slice: {
            count: Math.floor(Math.random() * 2) + 2,
            velocity: Math.floor(Math.random() * 5) + 5,
            minHeight: 0.02,
            maxHeight: 0.15,
            hueRotate: true,
        },
    });
});

PowerGlitch.glitch('.glitch--superlight', {
    playMode: 'always',
    createContainers: false,
    hideOverflow: false,
    timing: {
        duration: 5000,
        iterations: Infinity,
    },
    glitchTimeSpan: {
        start: 0,
        end: 1,
    },
    shake: {
        velocity: 0,
        amplitudeX: 0.1,
        amplitudeY: 0.1,
    },
    slice: {
        count: 3,
        velocity: 15,
        minHeight: 0.01,
        maxHeight: 0.02,
        hueRotate: true,
    },
});

PowerGlitch.glitch('.glitch--onclick', {
    playMode: 'click',
    createContainers: true,
    hideOverflow: true,
    glitchTimeSpan: {
        start: 0,
        end: 1,
    },
    shake: {
        velocity: 5,
        amplitudeX: 0.2,
        amplitudeY: 0.2,
    },
    slice: {
        count: 6,
        velocity: 15,
        minHeight: 0.02,
        maxHeight: 0.15,
        hueRotate: true,
    },
});


document.addEventListener("DOMContentLoaded", function (event) {

    // INIT MENUBUTTON
    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');
    menu_button.addEventListener('click', () => {
        document.body.classList.toggle('body--show');
    })

    // INIT LIGHTBOX
    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    // INIT SWIPER
    const sliders = document.querySelectorAll('.swiper');
    sliders.forEach(function (slider) {
        const autoSwiper = slider.classList.contains('swiper--auto');
        const swiper = new Swiper(slider, {
            // configure Swiper to use modules
            modules: [Pagination, Navigation, Autoplay, EffectFade],
            effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            direction: 'vertical',
            loop: true,

            autoplay: autoSwiper ? {
                delay: 5000,
            } : false,

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    });

    // FIXED HEADER
    window.addEventListener('scroll', () => {
        if (document.documentElement.scrollTop > 30 || document.body.scrollTop > 30){
            document.body.classList.add('menu--fixed');
        } else {
            document.body.classList.remove('menu--fixed');
        }
    });
});
